import styled from 'styled-components';

type IconWrapperProps = {
  done?: boolean;
  disabled?: boolean;
}

export const OnboardingIconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid ${props => props.disabled || props.done ? '#CFD6E5' : '#30BF78'};
  color:  ${props => props.disabled || props.done ? '#CFD6E5' : '#30BF78'};
  font-size: 16px;
  margin-bottom: 16px;
`;
